import { AuthorizedAPI } from 'config';
import { takeLatest, call, put } from 'redux-saga/effects';
import ApiServices from 'services/API/ApiServices';
import AuthActions, { AuthTypes } from '../redux/AuthRedux';
// import {
//   getError,
// } from '../services/Utils';

export function* onRequestLogin({ payload }) {
  const response = yield call(
    ApiServices[payload?.method],
    AuthorizedAPI,
    payload?.slug,
    payload?.data
  );
  if (response?.status === 200) {
    localStorage.setItem('token', response.data.data.accessToken);
    localStorage.setItem('refreshToken', response.data.data.refreshToken);
    yield put(
      AuthActions.loginSuccess({
        loader: payload?.loader,
        user: response?.data?.data
      })
    );
  } else {
    payload.onFailedLogin(response.data.error);
    yield put(
      AuthActions.loginFailure({
        loader: payload?.loader,
        error: response?.data
      })
    );
  }
}

export function* onRequestForgotPassword({ payload }) {
  const response = yield call(
    ApiServices[payload?.method],
    AuthorizedAPI,
    payload?.slug,
    payload?.data
  );
  if (response?.status === 200) {
    payload.onValidMail(response?.data?.link);
    yield put(
      AuthActions.forgotPasswordSuccess({
        loader: payload?.loader,
        link: response?.link
      })
    );
  } else {
    payload.onInvalidMail(response.data.error);
    yield put(
      AuthActions.forgotPasswordFailure({
        loader: payload?.loader,
        error: response?.data
      })
    );
  }
}

export function* onRequestChangePassword({ payload }) {
  const response = yield call(
    ApiServices[payload?.method],
    AuthorizedAPI,
    payload?.slug,
    payload?.data
  );
  if (response?.status === 200) {
    payload.onValidMail(response?.data?.link);
    yield put(
      AuthActions.changePasswordSuccess({
        loader: payload?.loader
      })
    );
  } else {
    payload.onInvalidMail(response.data.error);
    yield put(
      AuthActions.changePasswordFailure({
        loader: payload?.loader,
        error: response?.data
      })
    );
  }
}

export default [
  takeLatest(AuthTypes.LOGIN_REQUEST, onRequestLogin),
  takeLatest(AuthTypes.FORGOT_PASSWORD_REQUEST, onRequestForgotPassword),
  takeLatest(AuthTypes.CHANGE_PASSWORD_REQUEST, onRequestChangePassword)
];
